import { useNavigate } from 'react-router-dom';

export const useDashboardNavigation = () => {
  const navigate = useNavigate();

  const navigateToClients = () => navigate('/clientes');
  const navigateToObras = () => navigate('/obras');

  const scrollToObrasTab = () => {
    // Find the obras tab trigger and click it
    const obrasTab = document.querySelector('[value="obras"]') as HTMLElement;
    if (obrasTab) {
      obrasTab.click();
      // Scroll to top after a small delay
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    }
  };

  return {
    navigateToClients,
    navigateToObras,
    scrollToObrasTab,
  };
};